// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2OzvU","image":"styles_image__xeNnT","text":"styles_text__3Yeb7"};